import React, { Component } from 'react';
import styled from "styled-components"
import { Table, Spin, message } from 'antd'
import Dashboard from '@/components/DeviceStatusByIMEI/Dashboard.jsx'
import Filter from '@/components/DeviceStatusByIMEI/Filter.jsx'
import DeviceAPI from '@/API/device'
import dayjs from 'dayjs'
import { withTranslation } from 'react-i18next';

const DataTable = styled(Table)`
  margin-top:20px;
`

const Div = styled.div`
  padding:0 20px 20px;
`

class DeviceStatusByIMEI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statistics: null,
      loading: false,
      deviceStatusList: [],
      filter: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        size: 'small',
        showTotal: (total) => (this.props.t('Total items', { total: total }))
      }
    };
  }
  filterChange = (key, value) => {
    let field = {}
    field[key] = value
    this.setState(prevState => ({
      filter: {
        ...prevState.filter,
        ...field
      }
    }))
  }
  exp = () => {
    const { filter } = this.state
    if (filter.file) {
      let formData = new FormData()
      formData.append('file', filter.file)
      formData.append('findTotal', false)
      formData.append('export', true)
      DeviceAPI.getImeiListStatusStatistics(formData).then((res) => {
        message.success(res)
      })
    } else {
      message.warning(this.props.t('Import IMEIs first.'))
    }
  }
  search = (clear) => {
    const { filter } = this.state
    this.setState((prevState) => ({
      pagination: {
        ...prevState.pagination,
        current: 1
      }
    }))
    if (clear) {
      this.setState({ filter: { ...filter, file: null } }, () => {
        this.getStatistics()
        this.getData()
      })
    } else {
      this.getStatistics()
      this.getData()
    }
  }
  clear = () => {
    this.setState({ deviceStatusList: [], statistics: null })
  }
  getData = () => {
    const { filter, pagination } = this.state
    const { t } = this.props
    let imeiList
    if (filter.file) {
      let formData = new FormData()
      formData.append('file', filter.file)
      formData.append('findTotal', false)
      formData.append('export', false)
      formData.append('pageIndex', pagination.current - 1)
      formData.append('pageSize', pagination.pageSize)
      DeviceAPI.getImeiListStatusStatistics(formData).then((res) => {
        this.setState({ deviceStatusList: res.list })
      })
    } else if (filter.IMEI) {
      imeiList = [filter.IMEI]
      DeviceAPI.getImeiSingleStatusStatistics({
        imeiSet: imeiList,
        findTotal: false,
        pageIndex: pagination.current - 1,
        pageSize: pagination.pageSize
      }).then((res) => {
        if (res.list.length === 0) {
          return message.warning(t("not find"))
        }
        this.setState({ deviceStatusList: res.list })
      })
    } else {
      this.setState({ deviceStatusList: [] })
      message.warning(t("Enter IMEIs or upload an IMEI table."))
    }
  }
  getStatistics = () => {
    const { filter } = this.state
    // let imeiList
    if (filter.file) {
      let formData = new FormData()
      formData.append('file', filter.file)
      formData.append('findTotal', true)
      formData.append('export', false)
      DeviceAPI.getImeiListStatusStatistics(formData).then((res) => {
        this.setState((prevState) => ({
          statistics: res.total,
          pagination: {
            ...prevState.pagination,
            total: res.total.totalUploadCount
          }
        }))
      })
    } else {
      // imeiList=[filter.IMEI]
      // DeviceAPI.getImeiSingleStatusStatistics({
      //   imeiList:imeiList,
      //   findTotal:true
      // }).then((res)=>{
      //   this.setState({statistics:res.total})
      // })
      this.setState({ statistics: null })
    }
  }
  handleTableChange = (pagination) => {
    this.setState({
      pagination: pagination,
    }, () => {
      this.getData()
    });
  }
  render() {
    const { statistics, loading, deviceStatusList, pagination } = this.state;
    const { t } = this.props;
    const columns = [
      {
        title: t("Model"),
        dataIndex: 'productName'
      },
      {
        title: t('Marketing Name'),
        dataIndex: 'marketingName'
      },
      {
        title: t("IMEI"),
        dataIndex: 'imei'
      },
      {
        title: t('Status'),
        dataIndex: 'status'
      },
      {
        title: t('Status Effective Since'),
        dataIndex: 'statusActivatedDate',
        render: (text) => (dayjs(text).format('YYYY-MM-DD HH:mm:ss'))
      },
      {
        title: t('IMEI Activated On'),
        dataIndex: 'generateDate',
        render: (text) => (dayjs(text).format('YYYY-MM-DD HH:mm:ss'))
      }
    ];
    return (
      <div>
        {
          statistics ? <Dashboard data={statistics}></Dashboard> : null
        }
        <Filter filterChange={this.filterChange} search={this.search} clear={this.clear} exp={this.exp}></Filter>
        <Div>
          <Spin spinning={loading}>
            <DataTable columns={columns} dataSource={deviceStatusList} rowKey="index" pagination={pagination} onChange={this.handleTableChange}></DataTable>
          </Spin>
        </Div>
      </div>
    )
  }
}

export default withTranslation()(DeviceStatusByIMEI);